import React, { useEffect, useMemo } from 'react';
import { arrayOf, func, node, object, shape, string } from 'prop-types';
import classNames from 'classnames';

import SectionContainer from '../SectionContainer';
import css from './SectionTab.module.css';
import { useLocation } from 'react-router-dom';
import Accordion from '../../../../components/Accordion/Accordion';

const SectionTab = props => {
  const { sectionId, className, defaultClasses, appearance, blocks, options, callToAction } = props;

  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };
  const hasBlocks = blocks?.length > 0;
  const currentTab = params.get('tab');
  const question = params.get('question');
  const tabParam = callToAction.href;
  const isTabActive = tabParam && tabParam === currentTab;

  useEffect(() => {
    if (question) {
      document.getElementById(question)?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [question]);

  const panels = useMemo(() => {
    return blocks.map((block, ind) => {
      if (!block.text?.content) {
        return {
          id: block.callToAction.href,
          label: block.title.content,
        };
      }
      return {
        id: block.callToAction?.href || `${block.title.content}-${ind}`,
        label: block.title.content,
        content: block.text.content,
      };
    });
  }, [blocks]);

  const anchors = useMemo(() => {
    return blocks.filter(block => !block.text?.content && block.callToAction?.href);
  }, [blocks]);

  if (!isTabActive) {
    return null;
  }

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={css.root}
      contentClassName={css.sectionContent}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasBlocks ? (
        <div className={classNames(defaultClasses.blockContainer, css.blockContainer)}>
          <Accordion
            initialTab={question}
            panels={panels}
            panelLabelClassName={css.accordionLabel}
          />
        </div>
      ) : null}
    </SectionContainer>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

SectionTab.defaultProps = {
  className: null,
  rootClassName: null,
  defaultClasses: null,
  blocks: [],
  appearance: null,
  options: null,
};

SectionTab.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
  appearance: object,
  defaultClasses: shape({
    sectionDetails: string,
    title: string,
    description: string,
    ctaButton: string,
  }),
  blocks: arrayOf(object),
  options: propTypeOption,
};

export default SectionTab;
